import Network from 'lib/api/network';

export default {
  namespaced: true,

  state() {
    return {
      snoozeAllEndDate: '',
      snoozedAll: false,
      loading: false,
    };
  },

  mutations: {
    update(state, { key, value }) {
      state[key] = value;
    },
  },

  getters: {
    snoozeAllEndDate: (state) => state.snoozeAllEndDate,
    snoozedAll: (state) => state.snoozedAll,
    loading: (state) => state.loading,
  },

  actions: {
    fetchSnoozeStatus({ commit, dispatch }, userId) {
      commit('update', { key: 'loading', value: true });

      const response = Network.get(`/users/${userId}/snooze_intros/status`, {
        success: (data) => {
          commit('update', { key: 'snoozeAllEndDate', value: data.snooze_all_end_date || '' });
          commit('update', { key: 'snoozedAll', value: data.snoozed_all || false });
        },
        error: (error) => {
          dispatch('setErrorToast', 'Failed to load snooze status', { root: true });
        },
        complete: () => {
          commit('update', { key: 'loading', value: false });
        },
      });

      return response;
    },

    bulkUpdateSnooze({ commit, dispatch }, { userId, endDate }) {
      commit('update', { key: 'loading', value: true });

      const response = Network.patch(`/users/${userId}/snooze_intros/bulk_update`, {
        snooze_intros: { end_date: endDate },
      }, {
        success: (data) => {
          commit('update', { key: 'snoozeAllEndDate', value: data.snooze_all_end_date || endDate });
          commit('update', { key: 'snoozedAll', value: data.snoozed_all || true });
          dispatch('setSuccessToast', 'Successfully snoozed intros', { root: true });
        },
        error: (error) => {
          dispatch('setErrorToast', 'Failed to snooze intros', { root: true });
        },
        complete: () => {
          commit('update', { key: 'loading', value: false });
        },
      });

      return response;
    },

    destroyAllSnooze({ commit, dispatch }, userId) {
      commit('update', { key: 'loading', value: true });

      Network.delete(`/users/${userId}/snooze_intros/destroy_all`, {}, {
        success: (data) => {
          commit('update', { key: 'snoozeAllEndDate', value: '' });
          commit('update', { key: 'snoozedAll', value: false });
          dispatch('setSuccessToast', 'Successfully unsnoozed intros', { root: true });
        },
        error: (error) => {
          dispatch('setErrorToast', 'Failed to unsnooze intros', { root: true });
        },
        complete: () => {
          commit('update', { key: 'loading', value: false });
        },
      });
    },
  },
};
